import { createActionCreators, createReducerFunction, ImmerReducer } from "immer-reducer"

export type State = {

    FranceDisplayMode:{
        isChartMode:boolean
    }

    EuropeDisplayMode:{
        isChartMode:boolean
    }

    DepartmentsDisplayMode:{
        isChartMode:boolean
    }

    EVMCDisplayMode:{
        isChartMode:boolean
    }
}

export const initialState:State = {
    FranceDisplayMode:{
        isChartMode: true
    },

    EuropeDisplayMode:{
        isChartMode:true
    },

    DepartmentsDisplayMode:{
        isChartMode:true
    },

    EVMCDisplayMode:{
        isChartMode:true
    }
};

export class displayModeState extends ImmerReducer<State>{

    changeFranceDisplayMode(){
       this.draftState.FranceDisplayMode.isChartMode=!this.draftState.FranceDisplayMode.isChartMode
    }

    changeEuropeDisplayMode(){
        this.draftState.EuropeDisplayMode.isChartMode=!this.draftState.EuropeDisplayMode.isChartMode
    }

    changeDepartmentDisplayMode(){
        this.draftState.DepartmentsDisplayMode.isChartMode=!this.draftState.DepartmentsDisplayMode.isChartMode
    }

    changeEVMCDisplayMode(){
        this.draftState.EVMCDisplayMode.isChartMode=!this.draftState.EVMCDisplayMode.isChartMode
    }
}

export const DisplayModeAction = createActionCreators(displayModeState)
export const displayModereducerFunction = createReducerFunction(displayModeState,initialState)